export const isiPad = () => navigator.userAgent.match(/iPad/i) != null;
